import { combineReducers } from 'redux'
import locationReducer from './location'
import headermenuReducer from '../modules/headermenu'
import headermenutestReducer from '../modules/headermenutest'
import emailReducer from '../modules/email'
import { loadingBarReducer } from 'react-redux-loading-bar'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    location: locationReducer,
    menuList: headermenuReducer,
    posts: headermenutestReducer,
    email: emailReducer,
    loadingBar: loadingBarReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js